import React, { Component } from 'react'
import * as mat from 'material-ui';
import './style.css'

class FAQ extends Component {
    render() {
        return (
            <div>
                <div className='col-md-10 col-md-offset-1 col-xs-12 Faq'>
                    <mat.Paper zDepth={1} >
                        <mat.AppBar
                            title='FAQ'
                            titleStyle={{ textShadow: '0px 2px 3px gray', fontSize: '2.5em', fontWeight: 'bold', color: '#000000' }}
                            // className='text-center'
                            showMenuIconButton={false}
                            style={{ backgroundColor: '#ebf9fe', borderBottom: '2px solid lightgray' }}
                            zDepth={0}
                        />
                        <div style={{ backgroundColor: '#ebf9fe', paddingLeft: '5%', paddingRight: '5%' }}>
                            <div style={{ paddingBottom: 5, paddingTop: 5 }}>
                                <h3 style={{ color: 'gray' }}>1. Why 300 topics?</h3>
                                <p style={{ color: 'gray', fontSize: 16, fontFamily: 'arial' }}>
                                    Because English has many areas of knowledge and skills not to mention strategies and exceptions.
                                    Languagelab has mapped the ENTIRE range of English competencies from reading strategies, speed
                                    reading to phonemic awareness, phonetics to creative writing to make it easy for learner of any age.
                                </p>
                            </div>
                            <mat.Divider />
                            <div style={{ paddingBottom: 5, paddingTop: 5 }}>
                                <h3 style={{ color: 'gray' }}>2. How does Languagelab's system work?</h3>
                                <p style={{ color: 'gray', fontSize: 16, fontFamily: 'arial' }}>
                                    Students WATCH an animated video to learn the key idea in ONE area of knowledge or skill such as speed reading
                                     or characterisation with teacher guidance. Next, they PLAY a game that tests their knowledge; in classes, teachers will teach and provide worksheets on topics to perfect their practice.
                                </p>
                            </div>
                            <mat.Divider />
                            <div style={{ paddingBottom: 5, paddingTop: 5 }}>
                                <h3 style={{ color: 'gray' }}>3. What's Languagelab's system built with? </h3>
                                <ul style={{ color: 'gray', fontSize: 16, fontFamily: 'arial' }}>
                                    <li>It is built with 3 parts - animations, games and modules. </li>
                                    <li>Animations are videos for 300 English topics. </li>
                                    <li>Games are built to teach and test English knowledge. </li>
                                    <li>Modules are updated dynamically so learners get fresh content from our expert teachers in class first.</li>
                                </ul>
                            </div>
                            <mat.Divider />
                            <div style={{ paddingBottom: 5, paddingTop: 5 }}>
                                <h3 style={{ color: 'gray' }}>4. Why can't reading ALONE help to improve English? </h3>
                                <p style={{ color: 'gray', fontSize: 16, fontFamily: 'arial' }}>
                                    Reading is a passive exercise. We can learn SOME grammar and vocabulary in this way but since English has a whole
                                    range of skills and strategies, we need to master these too. It's like learning most skill-based knowledge like
                                    design and architecture - we need BOTH theory (vocabulary and grammar) and practical (skills and strategies).
                                </p>
                            </div>
                            <mat.Divider />
                            <div style={{ paddingBottom: 5, paddingTop: 5 }}>
                                <h3 style={{ color: 'gray' }}>5. What's the DIFFERENCE between yours and other learning systems?</h3>
                                <p style={{ color: 'gray', fontSize: 16, fontFamily: 'arial' }}>
                                    Languagelab has systemised and standardised English with 300 videos for every key idea. We then capture each key idea in
                                    animations with moving visuals and sound as most learners are visual and auditory. Finally, they are gamified to make them interesting for
                                    ALL levels of students. Children at a small age learn through play and older students prefer gaming too, as a quick test of ability.
                                <br />
                                <br />
                                    Most systems are either passive (animations or learning videos) or gamified (e-learning) with English grammar and vocabulary.
                                    We combine these two with 40 textbooks and 300 chapters to back up the learning.
                                </p>
                            </div>
                            <mat.Divider />
                            <div style={{ paddingBottom: 5, paddingTop: 5 }}>
                                <h3 style={{ color: 'gray' }}>6. What's the requirement to start learning English with Languagelab? </h3>
                                <p style={{ color: 'gray', fontSize: 16, fontFamily: 'arial' }}>
                                    Download our app. Then, for your child to perfect his practice, just register for any of Languagelab's classes with results guaranteed or extra classes free.
                                </p>
                            </div>
                            <mat.Divider />
                            <div style={{ paddingBottom: 5, paddingTop: 5 }}>
                                <h3 style={{ color: 'gray' }}>7. Do I need to buy any supplementary material if my child is already enrolled?</h3>
                                <p style={{ color: 'gray', fontSize: 16, fontFamily: 'arial' }}>
                                    There is no need to. All Languagelab students get access to use the full suite of our resources - videos, animations, textbooks, worksheets, past year papers and games - as part of the monthly fee.
                                </p>
                            </div>
                            <mat.Divider />
                            <br />

                            <div className='text-center' style={{ paddingBottom: 5, paddingTop: 5 }}>
                                <p style={{ color: 'gray', fontSize: 14, fontFamily: 'arial' }}>
                                    Languagelab Pte Ltd. Blk 335 Sembawang Close #01-475 S(750335). Tel: 81209133 Email: info@languagelab.sg
                                </p>
                            </div>
                        </div>

                    </mat.Paper>
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                </div>

            </div>
        )
    }
}

export default FAQ;


// WEBPACK FOOTER //
// ./src/component/Faq/faq.jsx